<template>
	<div class="mall-shop-page">
		<shop-workbench-nav active-key="my" />
		<div class="shop-panel" v-loading="loading">
			<div class="page-header">
				<div>
					<h3 class="page-title">{{ isChangeMode ? '店铺资料变更' : '店铺申请' }}</h3>
					<div class="page-sub">
						{{ isChangeMode ? '提交后需等待平台审核，审核通过后店铺资料才会更新。' : '请填写真实店铺资料，提交后平台会进行审核。' }}
					</div>
				</div>
				<el-button @click="handleBack">返回</el-button>
			</div>

			<el-form ref="shopFormRef" :model="formData" :rules="formRules" label-position="top" class="shop-form">
				<div class="section">
					<div class="section-title">基础信息</div>
					<el-row :gutter="32">
						<el-col :span="12">
							<el-form-item label="店铺名称" prop="shopName">
								<el-input v-model="formData.shopName" maxlength="50" show-word-limit placeholder="请输入店铺名称" clearable />
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="联系人" prop="contactPerson">
								<el-input v-model="formData.contactPerson" maxlength="20" placeholder="请输入联系人" clearable />
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="联系方式" prop="contactPhone">
								<el-input v-model="formData.contactPhone" maxlength="20" placeholder="请输入联系方式" clearable />
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="经营主体名称" prop="companyName">
								<el-input v-model="formData.companyName" maxlength="80" placeholder="请输入经营主体名称" clearable />
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-form-item label="经营地址" prop="businessAddress">
								<el-input v-model="formData.businessAddress" maxlength="120" placeholder="请输入经营地址" clearable />
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-form-item label="业务简介" prop="businessDesc">
								<el-input
									v-model="formData.businessDesc"
									type="textarea"
									:rows="5"
									maxlength="800"
									show-word-limit
									resize="none"
									placeholder="请输入店铺业务简介，不超过800字"
								/>
							</el-form-item>
						</el-col>
					</el-row>
				</div>

				<div class="section">
					<div class="section-title">结算信息</div>
					<el-row :gutter="32">
						<el-col :span="12">
							<el-form-item label="开户行名称" prop="bankName">
								<el-input v-model="formData.bankName" maxlength="80" placeholder="请输入开户行名称" clearable />
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="开户行账号" prop="bankAccount">
								<el-input v-model="formData.bankAccount" maxlength="40" placeholder="请输入开户行账号" clearable />
							</el-form-item>
						</el-col>
					</el-row>
				</div>

				<div class="section">
					<div class="section-title">
						附件资料
						<span class="section-sub">营业执照必填</span>
					</div>
					<el-row :gutter="32">
						<el-col :span="8">
							<el-form-item label="店铺 Logo">
								<upload-images
									v-model="logoFiles"
									:action="uploadAction"
									:data="logoUploadData"
									:headers="uploadHeaders"
									:preview-url="previewUrl"
									:delete-api="deleteApi"
									:delete-params="logoUploadData"
									:limit="1"
									:size="5"
									:tip="true"
								/>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="营业执照" prop="businessLicenseFiles">
								<upload-images
									v-model="businessLicenseFiles"
									:action="uploadAction"
									:data="businessLicenseUploadData"
									:headers="uploadHeaders"
									:preview-url="previewUrl"
									:delete-api="deleteApi"
									:delete-params="businessLicenseUploadData"
									:limit="1"
									:size="5"
									:tip="true"
								/>
							</el-form-item>
						</el-col>
					</el-row>
				</div>

				<div class="form-actions">
					<el-button @click="handleBack">取消</el-button>
					<el-button type="primary" :loading="submitLoading" @click="handleSubmit">
						{{ isChangeMode ? '提交变更申请' : '提交申请' }}
					</el-button>
				</div>
			</el-form>
		</div>
	</div>
</template>

<script>
	import UploadImages from '@/components/UploadImages'
	import ShopWorkbenchNav from './components/WorkbenchNav.vue'
	import {
		changeSubmitMerchantShopApply,
		deleteMerchantFile,
		previewMerchantFile,
		queryMyLatestShopApply,
		queryMyShop,
		submitMerchantShopApply,
		uploadMerchantFile
	} from '@/api/mall'
	import { getUuid } from '@/utils'
	import { getToken } from '@/utils/auth'
	import { SHOP_AUDIT_STATE, SHOP_APPLY_TYPE, SHOP_STATE } from '@/enum/index.js'

	export default {
		name: 'MallShopApply',
		components: {
			ShopWorkbenchNav,
			UploadImages
		},
		data() {
			return {
				loading: false,
				submitLoading: false,
				formData: {
					id: '',
					shopName: '',
					contactPerson: '',
					contactPhone: '',
					companyName: '',
					businessAddress: '',
					businessDesc: '',
					bankName: '',
					bankAccount: '',
					businessLicenseFiles: []
				},
				logoFiles: [],
				businessLicenseFiles: [],
				uploadAction: uploadMerchantFile(),
				previewUrl: previewMerchantFile(),
				deleteApi: deleteMerchantFile,
				formRules: {
					shopName: [{ required: true, message: '请输入店铺名称', trigger: 'blur' }],
					contactPerson: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
					contactPhone: [
						{ required: true, message: '请输入联系方式', trigger: 'blur' },
						{ pattern: /^1[3-9]\d{9}$|^0\d{2,3}-?\d{7,8}$/, message: '请输入正确的手机号或座机号', trigger: 'blur' }
					],
					companyName: [{ required: true, message: '请输入经营主体名称', trigger: 'blur' }],
					businessAddress: [{ required: true, message: '请输入经营地址', trigger: 'blur' }],
					businessDesc: [
						{ required: true, message: '请输入业务简介', trigger: 'blur' },
						{ max: 800, message: '业务简介不能超过800字', trigger: 'blur' }
					],
					bankName: [{ required: true, message: '请输入开户行名称', trigger: 'blur' }],
					bankAccount: [{ required: true, message: '请输入开户行账号', trigger: 'blur' }],
					businessLicenseFiles: [{ validator: this.validateBusinessLicense, trigger: 'change' }]
				}
			}
		},
		computed: {
			isChangeMode() {
				return this.$route.name === 'MallShopChange'
			},
			uploadHeaders() {
				return {
					InternetToken: getToken()
				}
			},
			logoUploadData() {
				return {
					businessId: this.formData.id,
					fileBusinessType: 'SHOP_LOGO'
				}
			},
			businessLicenseUploadData() {
				return {
					businessId: this.formData.id,
					fileBusinessType: 'BUSINESS_LICENSE'
				}
			}
		},
		watch: {
			businessLicenseFiles() {
				this.formData.businessLicenseFiles = this.businessLicenseFiles
				this.$nextTick(() => {
					this.$refs.shopFormRef && this.$refs.shopFormRef.validateField('businessLicenseFiles')
				})
			}
		},
		created() {
			this.formData.id = getUuid()
			this.initPage()
		},
		methods: {
			validateBusinessLicense(rule, value, callback) {
				if (!this.businessLicenseFiles.length) {
					callback(new Error('请上传营业执照'))
					return
				}
				callback()
			},
			async initPage() {
				this.loading = true
				try {
					if (this.isChangeMode) {
						const res = await queryMyShop()
						const shop = res.data || {}
						if (!shop.id || Number(shop.shopState) !== SHOP_STATE.NORMAL) {
							this.$message.warning('只有正常经营的店铺才能提交资料变更')
							this.$router.replace('/mall/shop/my')
							return
						}
						this.fillForm(shop)
					} else {
						const latestRes = await queryMyLatestShopApply().catch(() => ({ data: null }))
						const latestApply = latestRes.data || null
						if (latestApply && Number(latestApply.auditState) === SHOP_AUDIT_STATE.PENDING) {
							this.$router.replace({
								path: '/mall/shop/apply-detail',
								query: { id: latestApply.id }
							})
							return
						}
						if (latestApply && Number(latestApply.auditState) === SHOP_AUDIT_STATE.REJECT) {
							this.fillForm(latestApply)
						}
					}
				} finally {
					this.loading = false
				}
			},
			fillForm(data) {
				this.formData = {
					...this.formData,
					shopName: data.shopName || data.storeName || '',
					contactPerson: data.contactPerson || data.contactName || data.linkMan || '',
					contactPhone: data.contactPhone || data.telephone || data.mobile || '',
					companyName: data.companyName || data.subjectName || '',
					businessAddress: data.businessAddress || data.address || '',
					businessDesc: data.businessDesc || data.businessScope || data.introduction || '',
					bankName: data.bankName || '',
					bankAccount: data.bankAccount || ''
				}
			},
			getSubmitData() {
				return {
					...this.formData,
					applyType: this.isChangeMode ? SHOP_APPLY_TYPE.CHANGE : SHOP_APPLY_TYPE.OPEN,
					contactName: this.formData.contactPerson,
					telephone: this.formData.contactPhone,
					subjectName: this.formData.companyName
				}
			},
			handleSubmit() {
				this.$refs.shopFormRef.validate(async valid => {
					if (!valid) return
					this.submitLoading = true
					try {
						const submitApi = this.isChangeMode ? changeSubmitMerchantShopApply : submitMerchantShopApply
						await submitApi(this.getSubmitData())
						this.$message.success('提交成功，请等待平台审核')
						this.$router.push({
							path: '/mall/shop/apply-detail',
							query: { id: this.formData.id }
						})
					} finally {
						this.submitLoading = false
					}
				})
			},
			handleBack() {
				this.$router.push(this.isChangeMode ? '/mall/shop/my' : '/mall/index')
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import './shop.scss';
</style>
